<template>
	<v-list-item
		style="border: 1px solid #e0e0e0; border-radius: 5px"
	>
		<v-list-item-content>
			<v-list-item-title>
				<strong>{{ appType.name }}</strong>
			</v-list-item-title>
		</v-list-item-content>
		<v-list-item-action>
			<v-row no-gutters>
				<v-btn icon @click="showForm = true">
					<v-icon color="primary">edit</v-icon>
				</v-btn>
				<v-btn icon @click="showDeleteAppointmentType = true">
					<v-icon color="primary">delete</v-icon>
					<DeleteConfirmationDialog
						v-model="showDeleteAppointmentType"
						item="appointment_type"
						@delete="deleteAppointmentType"
					/>
				</v-btn>
        <v-dialog v-model="showForm" max-width="40%" scrollable>
          <v-card>
            <v-card-title class="title primary--text mb-2 secondary">
              <translate>Appointment Type</translate>
            </v-card-title>
            <v-card-text>
              <v-form ref="form">
                <v-row no-gutters class="mt-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="appType.name"
                      :label="$gettext('Name')"
                      filled
                      hide-details
                      class="pa-2"
                      :rules="[required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="showForm = false">
                <translate>Cancel</translate>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="editAppointmentType" key="save" :loading="savingAppointmentType">
                <translate>Save</translate>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
			</v-row>
		</v-list-item-action>
	</v-list-item>
</template>

<script>
import axios from "axios";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";

export default {
  name: "AppointmentType",
  props: ["appType", "pricing"],
  components: {
    DeleteConfirmationDialog
  },
  data: () => ({
    showDeleteAppointmentType: false,
    showForm: false,
    savingAppointmentType: false
  }),
  computed: {
    required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    deleteAppointmentType() {
      axios
        .post("/appointment-type/" + this.appType.id + "/delete")
          .then(response => {
            console.log(response.data);
            this.showDeleteAppointmentType = false;
            this.$emit('remove-appointment-type', this.appType);
          })
          .catch(error => {
            console.log(error);
            this.showDeleteAppointmentType = false;
          });
    },
    editAppointmentType() {
      if(this.$refs.form.validate()) {
        this.savingAppointmentType = true;
        let id = this.appType.id;
        let data = {
          name: this.appType.name
        }
        axios
          .post("/appointment-type/" + id + "/edit", data, {params: {pricing: false}})
          .then(response => {
            console.log(response.data);
            this.showForm = false;
            this.savingAppointmentType = false;
          })
          .catch(error => {
            console.log(error);
            this.savingAppointmentType = false;
          });
      }
    }
  }
}
</script>